<template>
  <div class="ProcessKycComponent">
    <!-- new mobile email verification dialog -->
    <el-dialog class="verify_otp_dialog new-mobile-email-verification-dialog" :visible.sync="isMobileVerificationDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div>
        <div class="flex-space-between bottom-margin-15">
          <div>
            <div class="text-left">
              <img src="../assets/images/logo/logo1.png" class="cursor-pointer" style="width: 170px" />
            </div>
            <h2>One Time Mobile Verification</h2>
          </div>
          <img src="../assets/images/MobileVerification/OTP Image.svg" width="100px" alt="" />
        </div>

        <div class="text-left">
          <div class="flex email-mobile-block" style="display: flex; align-items: center; flex-wrap: wrap">
            <el-select v-model="selectedCountryCode" placeholder="Code" size="mini" style="width: 90px; margin-bottom: 5px" filterable :popper-class="'dropdown-with-search'" class="custom-select" :disabled="is_mobile_verified">
              <template #prefix>
                <span v-if="selectedCountry">
                  <img :src="selectedCountry.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 5px; padding-top: 6px; vertical-align: middle" />
                </span>
              </template>

              <el-option v-for="country in countryCodes" :key="`${country.country_code}-${country.name}`" :label="`${country.country_code}`" :value="country.country_code">
                <span class="custom-label" style="display: flex; align-items: center">
                  <img :src="country.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 8px; vertical-align: middle" />
                  <span style="margin-right: 8px">{{ country.country_code }}</span>
                  {{ country.name }}
                </span>
              </el-option>
            </el-select>
            <!-- Mobile Number Input -->
            <div>
              <div
                class="form-group"
                :class="{
                  'not-empty': mobile_number.length,
                  'form-group--error': show_error_on_empty && $v.mobile_number.$error,
                }"
              >
                <el-input placeholder="xxx xxx xxxx" v-model="mobile_number" :maxlength="getMaxLength()" size="mini" @input="validateMobileNumber" style="width: 180px; margin-bottom: 5px" :disabled="is_mobile_verified"></el-input>
              </div>
            </div>

            <!-- OTP Button -->
            <el-button class="btn-secondary-theme-filled otp-btn left-margin-10" style="width: 80px; margin-bottom: 5px" size="mini;" @click="sendOTPForMobileVerification" v-loading="is_mobile_verification_loading" :disabled="!mobile_number.length" v-if="!is_mobile_verified">Get OTP</el-button>

            <!-- Verified Text -->
            <div class="left-margin-10 text-center verified-btn" v-else style="margin-left: 8px">Verified</div>
          </div>

          <!-- Validation Message Below -->
          <div style="color: red; font-size: 0.75em; word-break: normal; width: 100%; margin-top: 8px" v-if="mobile_number.length && !isValidMobileNumber">Mobile number must be exactly {{ getMaxLength() }} digits</div>

          <!-- Field Required Message -->
          <div class="error" v-if="show_error_on_empty && !$v.mobile_number.required" style="color: red; font-size: 0.75em; word-break: normal; margin-top: 8px">Field is required</div>

          <div class="top-margin-25 agreement-checkbox flex" style="align-items: flex-start">
            <el-checkbox v-model="notification_permission" disabled style="margin-top: 4px"></el-checkbox>
            <div class="left-margin-5 text">
              I accept
              <router-link to="/retail-side/terms-condition" style="color: #2d2e8d; text-decoration: none; font-weight: 600">terms and conditions</router-link>
              & Allow StockAnts to send notifications
            </div>
          </div>

          <div class="font-06rem cursor-pointer text-left top-margin-10" style="color: #000">
            <span style="color: #000; font-weight: 500">Note:</span>
            Enter your
            <span style="color: green">WhatsApp Number</span>
            for further communication
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- otp verification email/mobile dialog -->
    <el-dialog class="verify_otp_dialog new_email_mobile_otp_dialog" :visible.sync="otp_verification_dialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleCloseOtpPopup">
      <div>
        <img src="../assets/images/logo/logo1.png" class="cursor-pointer text-center" style="width: 150px" />
        <div class="save-btn-section top-margin-10">
          <div
            class="form-group text-left"
            :class="{
              'not-empty': otp.length,
              'form-group--error': $v.otp.$error,
            }"
          >
            <label class="input-label-bold-gray">OTP</label>
            &nbsp;
            <span class="required-field">*</span>

            <el-input class="top-margin-10" type="number" placeholder="OTP" size="mini" v-model="otp" @input="setOTP($event)"></el-input>
          </div>
          <div class="text-center">
            <el-button class="top-margin-10 btn-secondary-theme-filled" rounded style="width: 200px" :loading="verifyOtpLoading" @click="isActiveVerification == 'email' ? verifyEmailOTP(otp) : verifyMobileOTP(otp)">VERIFY OTP</el-button>
          </div>
        </div>

        <div class="font-08rem external-link-color font-weight-500 cursor-pointer text-center top-margin-10" @click="isActiveVerification == 'email' ? sendOTPForEmailVerification() : sendOTPForMobileVerification()">
          <span>Resend OTP</span>
        </div>
      </div>
    </el-dialog>

    <!-- Payment confirmation popup -->
    <el-dialog :visible.sync="isPlanPurchaseProcessDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="plan-subscription-notification-dialog">
      <div>
        <div class="payment-success-status">
          <div class="modal-content">
            <div class="new-model-inner">
              <div class="text-center top-margin-5">
                <span class="flex-center"><img src="../assets/images/SuccessfulIcon.svg" style="position: absolute; top: -35px" /></span>

                <div v-if="(getPlanSubscriptionStatus && !getPlanSubscriptionStatus.purchased_via_access_code) || getPublisherSubscriptionStatus">
                  <div v-if="getPlanSubscriptionPaymentStatus == true">
                    <h2 class="top-margin-25">Payment Successful!</h2>

                    <div class="chat-congratulation-text" v-if="getPlanSubscriptionStatus && getPlanSubscriptionStatus.plan == 'StockAnts Chat'">Congratulations! You have successfully subscribed for {{ getPlanSubscriptionStatus.total_chat_session == 1 ? 'StockAnts Chat!' : getPlanSubscriptionStatus.total_chat_session + 'StockAnts Chats!' }}</div>

                    <div v-if="userProfile.extra_info && !userProfile.extra_info.is_user_verified_with_signzy && getPlanSubscriptionStatus && getPlanSubscriptionStatus.plan == 'Premium' && getPlanSubscriptionStatus.access_code">
                      <div class="access-code-section" v-if="websiteUserType.userType != 'broker' && isPanCardVerified && !Object.keys(getPublisherSubscriptionStatus).length">
                        <div class="faded-border-bottom top-margin-20 bottom-margin-20">&nbsp;</div>

                        <div class="head">Access Code</div>

                        <div class="code-box head" id="access-code">
                          {{ getPlanSubscriptionStatus && getPlanSubscriptionStatus.access_code ? getPlanSubscriptionStatus.access_code : '-' }}
                        </div>

                        <div @click="copyTextToClipboard('access-code')" class="font-08rem external-link-color font-weight-500 cursor-pointer text-center" style="text-decoration: underline">Copy Code</div>
                        <div class="top-margin-15 font-07rem capitalize font-weight-500">
                          Use this code to get free
                          <br />
                          access on broker login & trade
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="!isPanCardVerified || (userProfile.extra_info && userProfile.extra_info.is_user_verified_with_signzy)">
                    <div class="agreement-text top-margin-20 bottom-margin-20" style="font-weight: 600">
                      You are only
                      <span style="color: #ea2526">1 step</span>
                      away
                    </div>
                    <img src="../assets/images/Group3530.svg" alt="" style="width: 190px; margin-left: 20px" />
                  </div>

                  <div class="agreement-text top-margin-20" v-if="getPlanSubscriptionPaymentStatus == true">
                    Invoice & StockAnts Agreement will be sent to your email ID
                    <!-- - {{ userProfile ? userProfile.email : "" }} -->
                  </div>
                  <!-- {{ isAadharCardVerified }}{{ isPanCardVerified
                  }}{{ isRiskProfileCompleted }} -->
                  <div v-if="!isPanCardVerified || !email.length || !is_email_verified || (userProfile.extra_info && userProfile.extra_info.is_user_verified_with_signzy)">
                    <div class="top-margin-15">
                      <el-button class="proceed-btn bottom-margin-15" :loading="verificationLoading" @click="showKycVerificationDialog()">Proceed to Verification</el-button>
                    </div>
                  </div>
                  <div v-else-if="isPanCardVerified && getPlanSubscriptionStatus && getPlanSubscriptionStatus.plan == 'StockAnts Chat'">
                    <el-button class="proceed-btn bottom-margin-15 top-margin-25" :loading="verificationLoading" @click="loadPageForChat()">Okay</el-button>
                  </div>
                  <div v-else>
                    <el-button
                      class="proceed-btn bottom-margin-15 top-margin-25"
                      :loading="verificationLoading"
                      @click="
                        // $store.commit('commitKycDialog', false);
                        loadPage()
                      "
                    >
                      Go to expert View
                    </el-button>
                  </div>
                </div>
                <div v-else>
                  <h2 class="top-margin-25">Congratulations!</h2>
                  <p v-if="getPlanSubscriptionStatus">
                    You are now
                    {{ getPlanSubscriptionStatus.plan }} Plan user
                  </p>

                  <div>
                    <el-button
                      class="proceed-btn bottom-margin-15 top-margin-25"
                      :loading="verificationLoading"
                      @click="
                        // $store.commit('commitKycDialog', false);
                        loadPage()
                      "
                    >
                      Okay
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="model-outline"></div>
        </div>
      </div>
    </el-dialog>

    <!-- Signzy KYC Popup -->
    <el-dialog class="kyc_dialog" :visible.sync="isKycBySignzyVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" @close="generateInvoiceRequest()">
      <div style="word-break: break-word" class="text-center flex-start">
        <div class="img-section desktop-view">
          <img src="../assets/images/logo/logo1.png" width="175px" alt="" />
          <img src="../assets/images/Confirm detail Illustration.svg" width="200px" height="250px" alt="" />
        </div>
        <div class="content-section text-left">
          <h3>
            Client Onboarding Verification
            <br />
            <span class="label-xss-black label-color font-weight-500">(This is a one Time Process)</span>
          </h3>
          <div>
            <div class="label-color">
              <div class="top-margin-10 bottom-margin-10">
                <div class="label-xss-black" style="margin-bottom: 3px">Email ID</div>
                <el-input v-model="email" size="mini" type="text" class="form-control email-box" placeholder="Email ID" name="user" :disabled="is_otp_sent || !isEmailEnable" @input="setEmail($event)"></el-input>
                <div style="position: relative">
                  <div style="position: absolute; right: 0; bottom: 2px; cursor: pointer; padding: 5px; background: #ffff">
                    <div v-if="!isEmailEnable && !isEmailEdit" @click="isEmailEnable = true" class="font-07rem font-weight-500" style="color: #2d2e8d">Edit</div>

                    <div v-if="isEmailEnable && !is_email_verified" @click="isEmailEdit ? sendOTPForEmailVerification() : ''" class="font-07rem font-weight-500" style="color: #2d2e8d">Verify</div>
                    <div v-if="isEmailEdit && is_email_verified">
                      <i class="el-icon-check" style="font-size: 20px; color: #21bc21; font-weight: 700; position: relative; top: 3px"></i>
                    </div>
                  </div>
                </div>
                <div v-if="validate_email_id" style="color: red; font-size: 0.75em; word-break: normal; margin-top: 2px">Enter valid Email id</div>
              </div>
              <div class="top-margin-10 bottom-margin-10">
                <div class="label-xss-black">Full Name</div>
                <div class="detail-box">
                  {{ userProfile.full_name ? userProfile.full_name : '-' }}
                </div>
              </div>
              <div class="flex-space-between flex-wrap">
                <div class="flex-space-between flex-wrap">
                  <div class="flex-container" style="display: flex; align-items: flex-start; gap: 0px; flex-wrap: wrap">
                    <!-- Pan Number Section -->
                    <div class="user-box" style="flex: 1; min-width: 200px">
                      <div class="label-xss-black">Pan Number</div>
                      <div class="detail-box">
                        {{ userProfile.pan_card_number ? userProfile.pan_card_number : '-' }}
                      </div>
                    </div>

                    <!-- Mobile Number Section -->
                    <div class="user-box" style="flex: 1; min-width: 300px; margin-top: 10px">
                      <div class="label-xss-black">Mobile Number</div>
                      <div style="display: flex; align-items: center; margin-bottom: 5px">
                        <!-- Country Code Dropdown -->
                        <el-select v-model="selectedCountryCode" placeholder="Code" size="mini" style="width: 100px; margin-right: 5px; background-color: #f5f7fa" filterable disabled :popper-class="'dropdown-with-search'" class="custom-select">
                          <el-option v-for="country in countryCodes" :key="`${country.country_code}-${country.name}`" :label="`${country.country_code}`" :value="country.country_code">
                            <span class="custom-label" style="display: flex; align-items: center">
                              <img :src="country.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 8px; background-color: #f5f7fa; vertical-align: middle" />
                              <span style="margin-right: 8px">{{ country.country_code }}</span>
                              {{ country.name }}
                            </span>
                          </el-option>
                        </el-select>

                        <!-- Mobile Number Input Field -->
                        <div style="flex-grow: 1; padding: 5px 10px; border: 1px solid #dcdfe6; background-color: #f5f7fa; border-radius: 4px; font-size: 12px; min-width: 150px">
                          {{ userProfile.mobile ? userProfile.mobile : 'Enter Mobile Number' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="top-margin-10 bottom-margin-10">
                <div class="label-xss-black" style="margin-bottom: 3px">GST(Optional)</div>
                <el-input v-model="gst_number" size="mini" type="text" class="form-control" placeholder="Enter your GST number" name="user" style="width: 100%" @input="setGst($event)" clearable></el-input>

                <div v-if="validate_gst_no && gst_number.length" style="color: red; font-size: 0.75em; word-break: normal; margin-top: 2px">Enter valid GST number</div>
              </div>

              <el-button class="btn-secondary-theme-filled otp-btn top-margin-15" style="width: 100%" @click="kycDone('signzy')" :disabled="!kyc_check || !notification_permission">Confirm Details</el-button>
            </div>
          </div>

          <div class="flex-start top-margin-20">
            <el-checkbox v-model="kyc_check"></el-checkbox>
            <span class="left-margin-10 font-06rem font-weight-500" style="margin-top: 4px">
              I agree to share my details with
              <span style="color: #2d2e8d; font-weight: 600">Stock</span>
              <span style="color: #e72726; font-weight: 600">Ants</span>
              for onboarding.
            </span>
          </div>
          <div class="flex-start top-margin-20" v-if="(websiteUserType && websiteUserType.userSubType == 'brokerWithoutPlans') || (currentEnvironment && currentEnvironment.byPassLogin)">
            <el-checkbox v-model="notification_permission"></el-checkbox>
            <div class="left-margin-10 font-06rem font-weight-500">
              I accept
              <span style="color: #409eff; font-weight: 600" @click="downloadSubscriptionAgreement()">StockAnts Subscription Agreement</span>
              ,
              <router-link to="/retail-side/terms-condition" style="color: #409eff; text-decoration: none; font-weight: 600">terms and conditions</router-link>
              & Allow StockAnts to send notifications
            </div>
          </div>

          <div class="flex-end top-margin-20">
            <div class="left-margin-10 font-06rem font-weight-500" style="margin-top: 4px">
              <i class="el-icon-info"></i>
              Help?
              <span style="color: #409eff; font-weight: 600">+91 9321765323</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- KYC popup -->
    <el-dialog class="kyc_dialog" :visible.sync="is_kyc_popup_visible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" @close="generateInvoiceRequest()">
      <div style="word-break: break-word" class="text-center flex-start">
        <div class="img-section desktop-view">
          <img src="../assets/images/logo/logo1.png" width="175px" alt="" />
          <img src="../assets/images/Confirm detail Illustration.svg" width="200px" height="250px" alt="" style="margin-top: 10px" />
        </div>
        <div class="content-section text-left">
          <h3>
            Client Onboarding Verification
            <br />
            <span class="label-xss-black label-color font-weight-500">(This is a one Time Process)</span>
          </h3>

          <div v-if="!isPanCardVerified">
            <el-collapse v-model="activeName" accordion v-if="!isPanCardVerified && userProfile && !userProfile.pan_card_number">
              <el-collapse-item title="PAN Card" name="1" :style="[validationMessage && validationMessage.length ? { border: '1px solid red !important' } : { border: 'none' }]">
                <div class="top-margin-10 label-color">
                  <div class="label-xss-black">PAN Card Number*</div>
                  <el-input placeholder="E.g. BV****30J" size="mini" v-model="pan_card_number" @input="handleInput"></el-input>
                  <el-button class="btn-secondary-theme-filled otp-btn top-margin-15" style="width: 100%" @click="validatePanCard()" :loading="verifyPanLoading" :disabled="!pan_card_number.length">Verify PAN</el-button>
                </div>
              </el-collapse-item>
            </el-collapse>

            <div class="flex-start" v-if="validationMessage && validationMessage.length">
              <img src="../assets/images/Caution Icon.svg" alt="" width="16px" />
              <span class="left-margin-10 font-06rem font-weight-500 required-field">
                {{ validationMessage }}
              </span>
            </div>

            <div class="faded-border-bottom top-margin-20 bottom-margin-20">&nbsp;</div>
          </div>

          <div v-if="isPanCardVerified">
            <div class="top-margin-10 bottom-margin-10">
              <div class="label-xss-black" style="margin-bottom: 3px">Email ID</div>
              <el-input v-model="email" size="mini" type="text" class="form-control email-box" placeholder="Email ID" name="user" :disabled="is_otp_sent || !isEmailEnable" @input="setEmail($event)">
                <!-- style="width: 350px;" -->
              </el-input>
              <div style="position: relative">
                <div style="position: absolute; right: 0; bottom: 2px; cursor: pointer; padding: 5px; background: #ffff">
                  <div v-if="!isEmailEnable && !isEmailEdit" @click="isEmailEnable = true" class="font-07rem font-weight-500" style="color: #2d2e8d">Edit</div>

                  <div v-if="isEmailEnable && !is_email_verified" @click="isEmailEdit ? sendOTPForEmailVerification() : ''" class="font-07rem font-weight-500" style="color: #2d2e8d">Verify</div>
                  <div v-if="isEmailEdit && is_email_verified">
                    <i class="el-icon-check" style="font-size: 20px; color: #21bc21; font-weight: 700; position: relative; top: 3px"></i>
                  </div>
                </div>
              </div>

              <div v-if="validate_email_id" style="color: red; font-size: 0.75em; word-break: normal; margin-top: 2px">Enter valid Email id</div>
            </div>
            <div class="label-color">
              <div class="top-margin-10 bottom-margin-10">
                <div class="label-xss-black">Full Name</div>
                <div class="detail-box">
                  {{ userProfile.full_name ? userProfile.full_name : '-' }}
                </div>
              </div>
              <div class="flex-space-between flex-wrap">
                <div class="flex-container" style="display: flex; align-items: flex-start; gap: 0px; flex-wrap: wrap">
                  <!-- Pan Number Section -->
                  <div class="user-box" style="flex: 1; min-width: 200px">
                    <div class="label-xss-black">Pan Number</div>
                    <div class="detail-box">
                      {{ userProfile.pan_card_number ? userProfile.pan_card_number : '-' }}
                    </div>
                  </div>

                  <!-- Mobile Number Section -->
                  <div class="user-box" style="flex: 1; min-width: 300px; margin-top: 10px">
                    <div class="label-xss-black">Mobile Number</div>
                    <div style="display: flex; align-items: center; margin-bottom: 5px">
                      <!-- Country Code Dropdown -->
                      <!-- <el-select v-model="selectedCountryCode" placeholder="Code" size="mini" style="width: 90px; background-color: #f5f7fa" filterable :popper-class="'dropdown-with-search'" class="custom-select" :disabled="is_mobile_verified">
                        <el-option v-for="country in countryCodes" :key="`${country.country_code}-${country.name}`" :label="`${country.country_code}`" :value="country.country_code">
                          <span class="custom-label" style="display: flex; align-items: center">
                            <img :src="country.flag" alt="flag" style="width: 20px; height: 15px; margin-right: 8px; background-color: #f5f7fa; vertical-align: middle" />
                            <span style="margin-right: 8px">{{ country.country_code }}</span>
                            {{ country.name }}
                          </span>
                        </el-option>
                      </el-select> -->
                      <div style="padding: 5px 10px; border: 1px solid #dcdfe6; margin-right: 5px; background-color: #f5f7fa; border-radius: 4px; font-size: 12px; min-width: 40px">
                        {{ userProfile.country_code ? userProfile.country_code : 'Enter Mobile Number' }}
                      </div>
                      <!-- Mobile Number Input Field -->
                      <div style="flex-grow: 1; padding: 5px 10px; border: 1px solid #dcdfe6; background-color: #f5f7fa; border-radius: 4px; font-size: 12px; min-width: 150px">
                        {{ userProfile.mobile ? userProfile.mobile : 'Enter Mobile Number' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="top-margin-10 bottom-margin-10">
                <div class="label-xss-black" style="margin-bottom: 3px">GST(Optional)</div>
                <!-- <div class="detail-box">
                </div> -->
                <el-input v-model="gst_number" size="mini" type="text" class="form-control" placeholder="Enter your GST number" name="user" style="width: 100%" @input="setGst($event)" clearable></el-input>

                <div v-if="validate_gst_no && gst_number.length" style="color: red; font-size: 0.75em; word-break: normal; margin-top: 2px">Enter valid GST number</div>
              </div>

              <el-button class="btn-secondary-theme-filled otp-btn top-margin-15" style="width: 100%" @click="kycDone()" :disabled="!isPanCardVerified || !kyc_check || !notification_permission">Confirm Details</el-button>
            </div>
          </div>

          <div class="flex-start top-margin-20">
            <el-checkbox v-model="kyc_check"></el-checkbox>
            <span class="left-margin-10 font-06rem font-weight-500" style="margin-top: 4px">
              I agree to share my details with
              <span style="color: #2d2e8d; font-weight: 600">Stock</span>
              <span style="color: #e72726; font-weight: 600">Ants</span>
              for onboarding.
            </span>
          </div>

          <div class="flex-start top-margin-20" v-if="(websiteUserType && websiteUserType.userSubType == 'brokerWithoutPlans') || (currentEnvironment && currentEnvironment.byPassLogin)">
            <el-checkbox v-model="notification_permission"></el-checkbox>
            <div class="left-margin-10 font-06rem font-weight-500">
              I accept

              <span style="color: #409eff; font-weight: 600" @click="downloadSubscriptionAgreement()">StockAnts Subscription Agreement</span>
              ,
              <router-link to="/retail-side/terms-condition" style="color: #409eff; text-decoration: none; font-weight: 600">terms and conditions</router-link>
              & Allow StockAnts to send notifications
            </div>
          </div>

          <div class="flex-end top-margin-20">
            <div class="left-margin-10 font-06rem font-weight-500" style="margin-top: 4px">
              <i class="el-icon-info"></i>
              Help?
              <span style="color: #409eff; font-weight: 600">+91 9321765323</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- KYC process completed status popup -->
    <el-dialog class="kyc-completed-popup" :visible.sync="is_kyc_Completed_popup_visible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="flex-center text-center">
        <img src="../assets/images/SuccessfulIcon.svg" style="position: absolute; top: -35px" alt="" />

        <div>
          <h2 class="top-margin-25">Completed!</h2>

          <div class="access-code-section">
            <div class="faded-border-bottom top-margin-20 bottom-margin-20">&nbsp;</div>

            <div class="head">Access Code</div>

            <div class="code-box head" id="access-code">
              {{ getPlanSubscriptionStatus ? getPlanSubscriptionStatus.access_code : '-' }}
            </div>

            <div class="top-margin-15 font-08rem capitalize font-weight-500" style="color: #8c8c8c">
              Use this code to get free
              <br />
              access on broker login & trade
            </div>

            <div class="top-margin-15 bottom-margin-15 font-08rem capitalize font-weight-600">
              Access code >>
              <router-link to="/my-account" class="external-link-color">My Account</router-link>
            </div>
          </div>
          <el-button class="top-margin-10 btn-secondary-theme-filled" rounded style="width: 100%; padding: 8px" @click="loadPage()">Okay</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- premium plan subscription notification dialog -->
    <el-dialog v-if="userProfile && campaignData && campaignData.campaign_data" class="plan-notification-dialog" :visible.sync="plan_sub_notification_dialog_visibility" :lock-scroll="true" :before-close="removePlanDialog">
      <div class="gift-container">
        <img src="./../assets/images/SuccessfulIcon.svg" class="gift-image" />

        <div class="dialog-content">
          <div class="congratulations">
            <div class="congratulations-message">Congratulations!</div>

            <hr class="centered-line" />

            <div class="plan-status">
              <p>
                You are now StockAnts
                {{ campaignData.campaign_data.plan_name }} User.
              </p>
              <p>Access {{ campaignData.campaign_data.heading }}</p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

     <!-- <div>
    <StockAntsChatPopup
      :visible.sync="showChatPopup"
    />
  </div> -->
  </div>
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import { serverAddr, serverHostName } from '../networkConfig';
import CripNotice from 'crip-vue-notice';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
// import StockAntsChatPopup from '../components/StockAntsChatPopup.vue';
// import { shouldShowChatPopup } from '../mixins/ChatPopupUtils.js';

export default {
  name: 'ProcessKycComponent',
  props: ['planDetails'],
  mixins: [updateProfileNetworkCallBack],
  // components: { StockAntsChatPopup },

  data() {
    return {
      serverHostName: serverHostName,
      mobile_number: '',
      otp: '',
      is_mobile_verification_loading: false,
      otp_verification_dialog: false,
      is_mobile_verified: false,
      mo_no_validation: false,
      userProfile: localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : {},
      captchaFailed: false,
      isAadharCardVerified: false,
      isPanCardVerified: false,
      verificationLoading: false,
      captchaOrderType: 'NEW',
      proceed_to_kyc_dialog_visible: false,
      captcha_otp_validate_dialog_visible: false,
      is_kyc_Completed_popup_visible: false,
      is_kyc_popup_visible: false,
      show_error_on_empty: true,
      kyc_check: true,
      notification_permission: true,
      isActiveVerification: '',
      activeName: '1',
      aadhar_card_number: '',
      pan_card_number: '',
      captcha: '',
      steps: ['1', '2', '3', '4', '5', '6'], // Add your steps here
      currentStep: 1, // Set the current step dynamically
      riskProfileQuestion: [],
      selected_ans_id: null,
      showRiskProfileResult: false,
      riskProfileResult: null,
      verificationLoading: false,
      generateAadharOtpLoading: false,
      verifyOtpLoading: false,
      verifyPanLoading: false,
      imageSrc: '',
      imageLoaded: false,
      session_id: null,
      isRiskProfileCompleted: false,
      planPurchaseDialogStatus: false,
      websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
      validationMessage: '',
      isRiskProfilePopupVisible: false,
      isMobileVerificationDialogVisible: false,
      isPlanPurchaseProcessDialogVisible: false,
      isPlanPurchaseProcessDialogVisibleForChat: false,
      isKycBySignzyVisible: false,
      is_otp_sent: false,
      mobile_email_verification_dialog: false,
      is_email_verification_loading: false,
      email: '',
      validate_email_id: false,
      validate_gst_no: false,
      is_email_verified: false,
      isEmailEnable: false,
      isEmailEdit: false,
      existing_email: '',
      plan_sub_notification_dialog_visibility: false,
      gst_number: null,
      isLoading: true,
      selectedCountryCode: '+91',
      countryCodes: [
        {
          name: 'India',
          country_code: '+91',
          flag: require('@/assets/images/Country-flags/India.svg'),
          length: 10,
        },
        {
          name: 'Singapore',
          country_code: '+65',
          flag: require('@/assets/images/Country-flags/Singapore.svg'),
          length: 8,
        },
        {
          name: 'United States',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/United States.svg'),
          length: 10,
        },
        {
          name: 'Canada',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/Canada.svg'),
          length: 10,
        },
        {
          name: 'Dubai',
          country_code: '+971',
          flag: require('@/assets/images/Country-flags/Dubai.svg'),
          length: 9,
        },
        {
          name: 'Saudi Arabia',
          country_code: '+966',
          flag: require('@/assets/images/Country-flags/Saudi Arabia.svg'),
          length: 9,
        },
        {
          name: 'Oman',
          country_code: '+968',
          flag: require('@/assets/images/Country-flags/Oman.svg'),
          length: 8,
        },
        {
          name: 'United Kingdom',
          country_code: '+44',
          flag: require('@/assets/images/Country-flags/United Kingdom.svg'),
          length: 10,
        },
        {
          name: 'Australia',
          country_code: '+61',
          flag: require('@/assets/images/Country-flags/Australia.svg'),
          length: 9,
        },
      ],
      // showChatPopup: false,
    };
  },
  validations: {
    mobile_number: {
      required,
    },
    otp: {
      required,
    },
  },
  mounted() {
    this.checkCampaign();

    this.userProfile = this.getProfileFromLocalStorage(); // use safe method
    this.updateProfileData();

    this.checkEmailValidationStatus();

    // Listen for storage updates (for syncing between tabs/windows)
    window.addEventListener('storage', this.onStorageChange);
  },
  watch: {
    campaignData(newValue) {
      this.checkCampaignDataStatus();
    },
    isKycBySignzyVisible(newValue) {
      this.updateScrollLock(newValue);
    },
    isPlanPurchaseProcessDialogVisible(newValue) {
      this.updateScrollLock(newValue);
    },
    isMobileVerificationDialogVisible(newValue) {
      this.updateScrollLock(newValue);
    },
    is_kyc_popup_visible(newValue) {
      this.updateScrollLock(newValue);
    },
    is_kyc_Completed_popup_visible(newValue) {
      this.updateScrollLock(newValue);
    },
    aadhar_card_number(newValue, oldValue) {
      if (newValue == null || oldValue == null) {
        this.aadhar_card_number = '';
      }
    },
    pan_card_number(newValue, oldValue) {
      if (newValue == null || oldValue == null) {
        this.pan_card_number = '';
      }
    },
  },
  methods: {
    checkEmailValidationStatus() {
      // Check and assign email values safely
      if (this.userProfile && this.userProfile.email && this.userProfile.email.length) {
        const extra = this.userProfile.extra_info;

        if (!extra || (extra && !extra.custom_email)) {
          this.email = this.userProfile.email;
          this.existing_email = this.userProfile.email;
          this.is_email_verified = this.userProfile.email_verified === true;
        } else {
          this.isEmailEnable = true;
        }
      } else {
        this.isEmailEnable = true;
      }
    },

    getProfileFromLocalStorage() {
      try {
        const stored = localStorage.getItem('profile');
        return stored ? JSON.parse(stored) : {};
      } catch (e) {
        console.error('Error parsing profile from localStorage:', e);
        return {};
      }
    },

    onStorageChange(event) {
      if (event.key === 'profile') {
        this.updateProfileData();
      }
    },
    // Get the max length for the selected country code
    getMaxLength() {
      const selectedCountry = this.countryCodes.find((country) => country.country_code === this.selectedCountryCode);
      return selectedCountry ? selectedCountry.length : 10; // Default to 10 if not found
    },
    // Validate the mobile number length
    validateMobileNumber() {
      const maxLength = this.getMaxLength();
      this.isValidMobileNumber = this.mobile_number.length === maxLength;
    },

    loadPageForChat() {
      this.isPlanPurchaseProcessDialogVisible = false;
      this.$store.commit('storePlanStatus', {});
    },
    downloadSubscriptionAgreement() {
      window.open(`${this.serverHostName}/Media/important_doc/StockAntsSubscriptionAgreement.pdf`, '_blank');
    },
    checkKYCStatus() {
      var userPlanDetails = JSON.parse(localStorage.getItem('plan_details'));

      var userPublisherPlanDetails = JSON.parse(localStorage.getItem('publisher_plan_details'));

      if (!userPlanDetails.purchased_via_access_code) {
        if (!this.userProfile.mobile || !this.userProfile.mobile_verified) {
          this.isMobileVerificationDialogVisible = true;
        } else if (userPlanDetails.plan == 'Premium' && (this.$route.path == '/experts-past-recommendations' || this.$route.path == '/expert-past-strategy-options' || this.$route.path == '/data-categorisation')) {
          this.checkDialogueStatus();
        } else if (userPublisherPlanDetails.plan == 'Publisher' && (this.$route.path == '/publish-recommendation-options' || this.$route.path == '/upload-recommendation')) {
          this.checkDialogueStatus();
        }
      }
    },
    checkDialogueStatus() {
      if (this.userProfile.extra_info && this.userProfile.extra_info.is_user_verified_with_signzy && !this.userProfile.extra_info.kyc_confirmation) {
        this.isPlanPurchaseProcessDialogVisible = false;
        this.isKycBySignzyVisible = true;
      } else {
        if (!this.userProfile.pan_card_number.length || !this.email.length || !this.is_email_verified || (this.userProfile.extra_info && !this.userProfile.extra_info.kyc_confirmation)) {
          this.is_kyc_popup_visible = true;
        }
      }
    },

    checkCampaignDataStatus() {
      if (!this.campaignData) {
        setTimeout(() => {
          this.checkKYCStatus();
        }, 1000);
      }
    },
    removePlanDialog() {
      this.plan_sub_notification_dialog_visibility = false;

      setTimeout(() => {
        this.checkKYCStatus();
      }, 1000);

      if (this.campaignData.campaign_data) {
        serverAddr
          .patch(`/base/v1/campaign/${this.campaignData.id}`, {
            seen: true,
          })
          .then((response) => {
            if (response.data.status) {
            }
          })
          .catch(
            function (error) {
              console.log(error);
            }.bind(this)
          );
      }
    },
    handleInput() {
      // Convert the input text to uppercase
      this.pan_card_number = this.pan_card_number.toUpperCase();
    },
    loadPage() {
      this.isPlanPurchaseProcessDialogVisible = false;
      if (this.getPlanSubscriptionStatus && this.getPlanSubscriptionStatus.plan == 'Premium') {
        if (this.getPlanSubscriptionPaymentStatus == true) {
          this.$router.push('/data-categorisation');
        }
      } else if (this.getPublisherSubscriptionStatus && this.getPublisherSubscriptionStatus.plan == 'Publisher') {
        this.$router.push('/upload-recommendation');
      } else {
        window.location.reload();
      }

      this.is_kyc_Completed_popup_visible = false;
      this.$store.commit('storePlanStatus', []);
    },

    showKycVerificationDialog() {
      if (this.userProfile.extra_info && this.userProfile.extra_info.is_user_verified_with_signzy) {
        this.isPlanPurchaseProcessDialogVisible = false;
        this.isKycBySignzyVisible = true;
      } else {
        if (this.isPanCardVerified && this.is_email_verified) {
          this.is_kyc_Completed_popup_visible = true;
        } else {
          // this.generateCaptcha();
          this.is_kyc_popup_visible = true;
          this.isPlanPurchaseProcessDialogVisible = false;
        }
      }
      this.$store.commit('storePlanStatus', {});
    },

    validatePanCard() {
      this.isPanCardVerified = false;
      this.verifyPanLoading = true;
      this.validationMessage = '';
      serverAddr
        .post('/auth/v1/pan/validate', {
          document_type: 'PAN',
          id_number: this.pan_card_number,
          name: this.userProfile.full_name,
        })
        .then((response) => {
          if (response.data.status && response.data.data.kyc_status) {
            new CripNotice({
              title: 'Success',
              description: response.data.validation,
              type: 'success',
              duration: 2,
            });
            this.isPanCardVerified = true;
            this.getUserProfile();
            this.validationMessage = '';
            // this.$store.commit("commitKycDialog", false);
          } else if (response.data.status && !response.data.data.kyc_status) {
            this.validationMessage = response.data.data.message;
            this.pan_card_number = '';
          } else {
            this.pan_card_number = '';
          }
          this.verifyPanLoading = false;
        })
        .catch((error) => {
          this.verifyPanLoading = false;
          this.validationMessage = '';

          console.log(error);
        });
    },
    setOTP(value) {
      this.otp = value;
      this.$v.otp.$touch();
    },

    setEmail(value) {
      this.email = value.trim();
      // this.$v.email.$touch();

      let email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (this.email.match(email_regex)) {
        this.validate_email_id = false;
      } else {
        this.validate_email_id = true;
      }

      this.isEmailEdit = true;
      this.is_email_verified = false;
    },

    setGst(value) {
      this.gst_number = value.trim();

      let gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;

      if (this.gst_number.match(gstRegex)) {
        this.validate_gst_no = false;
      } else {
        this.validate_gst_no = true;
      }

      // return gstRegex.test(gstNumber);
    },

    setMobile(value) {
      if (value) {
        this.mobile_number = value.trim();
        this.$v.mobile_number.$touch();
        var numbers = /^[0-9]+$/;
        if (this.mobile_number.match(numbers)) {
          this.mo_no_validation = false;
          if ((this.mobile_number[0] != 0 && this.mobile_number.length === 10) || (this.mobile_number[0] == 0 && this.mobile_number.length === 11)) {
            this.mo_no_validation = false;
          } else {
            this.mo_no_validation = true;
          }
        } else {
          this.mo_no_validation = true;
        }
      }
    },

    // api to send otp on email id.
    sendOTPForEmailVerification() {
      this.is_email_verification_loading = true;

      if (this.email && !this.validate_email_id) {
        serverAddr
          .post('/auth/v1/generate_email_otp', {
            email_id: this.email,
            purpose: 'BROKER_EMAIL_VERIFICATION',
          })
          .then((response) => {
            if (response.data.status) {
              this.otp = '';

              this.mobile_email_verification_dialog = false;
              this.otp_verification_dialog = true;

              this.isActiveVerification = 'email';

              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 2,
              });
            }
            this.is_email_verification_loading = false;
          })
          .catch((error) => {
            this.is_email_verification_loading = false;
            console.log(error);
          });
      } else {
        this.is_email_verification_loading = false;
      }
    },

    // api to send otp on mobile no.
    sendOTPForMobileVerification() {
      if (this.mobile_number && !this.mo_no_validation) {
        this.is_mobile_verification_loading = true;
        serverAddr
          .post('/auth/v1/generate_mobile_otp', {
            country_code: this.selectedCountryCode,
            mobile: this.mobile_number,
            purpose: 'MOBILE_VERIFICATION',
          })
          .then((response) => {
            if (response.data.status) {
              this.otp = '';

              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 2,
              });

              this.isActiveVerification = 'mobile';

              this.mobile_email_verification_dialog = false;
              this.otp_verification_dialog = true;
            }
            this.is_mobile_verification_loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.is_mobile_verification_loading = false;
          });
      }
    },

    // api to verify mobile otp
    verifyMobileOTP(otp) {
      if (this.mobile_number && !this.mo_no_validation && this.otp) {
        this.is_mobile_verification_loading = true;
        this.verifyOtpLoading = true;
        var otp = otp;
        serverAddr
          .post('/auth/v1/validate_mobile_otp', {
            country_code: this.selectedCountryCode,
            mobile: this.mobile_number,
            mobile_otp: Number(otp),
            user_id: this.userProfile.id,
            purpose: 'MOBILE_VERIFICATION',
          })
          .then((response) => {
            if (response.data.status) {
              this.getUserProfile();
              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 2,
              });
              this.otp = '';
              this.otp_verification_dialog = false; //closed dialog to verify otp
              this.isMobileVerificationDialogVisible = false; //closed dialog to verify Mobile
              this.is_mobile_verified = true;
              this.userProfile.mobile_verified = true;
              setTimeout(() => {
                this.checkAadharStatus();
              }, 1000);
            }
            this.is_mobile_verification_loading = false;
            this.verifyOtpLoading = false;
          })
          .catch((error) => {
            this.is_mobile_verification_loading = false;
            this.verifyOtpLoading = false;
            console.log(error);
            new CripNotice({
              title: 'Error',
              description: response.data.validation,
              type: 'error',
              duration: 2,
            });
          });
      }
    },

    checkAadharStatus() {
      var userPlanDetails = JSON.parse(localStorage.getItem('plan_details'));
      if (userPlanDetails.plan == 'Premium' || userPlanDetails.plan == 'Pro') {
        if (this.userProfile.extra_info && this.userProfile.extra_info.is_user_verified_with_signzy) {
          this.isPlanPurchaseProcessDialogVisible = false;
          this.isKycBySignzyVisible = true;
        } else {
          if (!this.userProfile.pan_card_number.length) {
            this.isPlanPurchaseProcessDialogVisible = true;
          }
        }
      }
    },

    // api to verify email id
    verifyEmailOTP() {
      this.is_email_verification_loading = true;
      this.verifyOtpLoading = true;
      if (this.email && !this.validate_email_id && this.otp) {
        serverAddr
          .post('/auth/v1/validate_email_otp', {
            email_id: this.email,
            email_otp: Number(this.otp),
            profile_id: this.userProfile.id,
            purpose: 'BROKER_EMAIL_VERIFICATION',
          })
          .then((response) => {
            if (response.data.status) {
              this.is_email_verified = true; //to show verified text
              this.validate_email_otp = false;
              this.otp_verification_dialog = false;

              this.getUserProfile();

              new CripNotice({
                title: 'Success',
                description: response.data.validation,
                type: 'success',
                duration: 2,
              });

              this.captcha_otp_validate_dialog_visible = false; //closed dialog to verify otp
              this.otp = '';
              this.isEmailEnable = false;
            }
            this.is_email_verification_loading = false;
            this.verifyOtpLoading = false;
            // this.isEmailEdit = false;
          })

          .catch((error) => {
            console.log(error);
            this.verifyOtpLoading = false;
            this.is_email_verification_loading = false;
          });
      }
    },
    async getUserProfile() {
      try {
        const response = await serverAddr.get('/auth/v1/profile');
        this.getProfileCallBack(response);
        await this.updateProfileData();
      } catch (error) {
        console.log(error);
      }
    },
    handleCloseOtpPopup() {
      this.captcha_otp_validate_dialog_visible = false;
      this.otp_verification_dialog = false;
      this.validate_email_otp = false; //to toggle otp buttons
      this.validate_mobile_otp = false; //to toggle otp buttons
    },
    updateScrollLock(value) {
      if (value) {
        // this.disableScroll(value); // Disable scrolling on body
        document.body.classList.add('no-scroll');
      } else {
        // this.enableScroll(value); // Enable scrolling on body
        document.body.classList.remove('no-scroll');
      }
    },

    kycDone(value) {
      const showNotice = (title, description, type) => {
        new CripNotice({ title, description, type, duration: 2 });
      };

      if (!this.email || !this.email.length || (!this.is_email_verified && this.existing_email !== this.email)) {
        showNotice('Error', 'Please verify your email to proceed', 'error');
        return;
      }

      if (value === 'signzy') {
        this.changeProfileStatus('signzy');
      }

      if (this.gst_number && this.gst_number.length) {
        if (this.validate_gst_no) {
          showNotice('Error', 'Please enter a valid GST number to proceed', 'error');
          return;
        } else {
          this.changeProfileStatus('gst_number');
        }
      }

      showNotice('Success', 'Client onboarding has been successfully completed.', 'success');

      // this.getRiskProfileQuestion();
      this.is_kyc_popup_visible = false;
      this.isPlanPurchaseProcessDialogVisible = false;
      this.isKycBySignzyVisible = false;
      // this.isRiskProfilePopupVisible = true;

      if (this.getPlanSubscriptionPaymentStatus == true && this.websiteUserType.userType != 'broker' && this.getPlanSubscriptionStatus && this.getPlanSubscriptionStatus.plan != 'StockAnts Chat') {
        this.is_kyc_Completed_popup_visible = true;
      }
    },

    changeProfileStatus(value) {
      // saveGstToProfile
      var queryParam = {};
      if (value == 'signzy') {
        queryParam.is_user_verified_with_signzy = false;
      } else if (value == 'gst_number') {
        queryParam.gst_number = this.gst_number;
      }
      serverAddr
        .post('/auth/v1/partial_profile_update', queryParam)
        .then((response) => {
          this.getProfileCallBack(response);
          this.userProfile = this.getProfileFromLocalStorage();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    generateInvoiceRequest() {
      serverAddr
        .get('/auth/v1/kyc_confirmation')
        .then((response) => {
          if (response.data.status) {
            setTimeout(() => {
              // Retrieve the profile object from localStorage
              var profile_data = JSON.parse(localStorage.getItem('profile'));

              // Modify the kyc_confirmation key because API succeed
              profile_data.extra_info.kyc_confirmation = true;

              // Save the updated Profile back to localStorage
              localStorage.setItem('profile', JSON.stringify(profile_data));
            }, 1000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // updateProfileData() {
    //   this.userProfile = JSON.parse(localStorage.getItem('profile'));

    //   setTimeout(() => {
    //     if (this.userProfile) {
    //       if (this.userProfile.pan_card_number && this.userProfile.pan_card_number.length) {
    //         this.pan_card_number = this.userProfile.pan_card_number;
    //         this.isPanCardVerified = true;
    //       }
    //     }
    //     this.planPurchaseDialogStatus = this.checkPlanPurchaseDialogStatus();
    //   }, 1000);
    // },

    updateProfileData() {
      this.userProfile = this.getProfileFromLocalStorage();

      if (this.userProfile && this.userProfile.pan_card_number && this.userProfile.pan_card_number.length) {
        this.pan_card_number = this.userProfile.pan_card_number;
        this.isPanCardVerified = true;
      }

      this.planPurchaseDialogStatus = this.checkPlanPurchaseDialogStatus();
    },

    checkPlanPurchaseDialogStatus() {
      if ((this.getPlanSubscriptionStatus && this.getPlanSubscriptionStatus.plan == 'Premium') || (this.getPublisherSubscriptionStatus && this.getPublisherSubscriptionStatus.plan == 'Publisher')) {
        if (!this.isPanCardVerified) {
          return true;
        } else {
          return false;
        }
      } else if (this.getPlanSubscriptionPaymentStatus) {
        return true;
      } else {
        return false;
      }
    },
  },

  computed: {
    selectedCountry() {
      return this.countryCodes.find((country) => country.country_code === this.selectedCountryCode) || null;
    },
    getPlanSubscriptionStatus() {
      if (this.$store.state.planStatus && this.$store.state.planStatus.data) {
        this.planSubscriptionStatusDetails = this.$store.state.planStatus;
        if (this.planSubscriptionStatusDetails && this.planSubscriptionStatusDetails.extra_info.transaction_status == 'SUCCESS') {
          if (this.planSubscriptionStatusDetails.data.plan == 'Publisher') {
            localStorage.setItem('publisher_plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
          } else if (this.planSubscriptionStatusDetails.data.plan == 'StockAnts Chat') {
            localStorage.setItem('chat_plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
          } else {
            localStorage.setItem('plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
          }
          this.isPlanPurchaseProcessDialogVisible = true;
        }
      }
      return this.$store.state.planStatus.data;
    },

    getPlanSubscriptionPaymentStatus() {
      return this.$store.state.isPaymentSuccess;
    },

    getPublisherSubscriptionStatus() {
      return this.$store.state.planStatus.message && this.$store.state.planStatus.message.data.plan == 'Publisher' ? this.$store.state.planStatus.message.data : {};
    },
  },

  beforeDestroy() {
    window.removeEventListener('storage', this.onStorageChange);
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.el-popup-parent--hidden {
  overflow: hidden !important;
}

.ProcessKycComponent {
  .verified-block {
    padding: 13px 20px 13px 13px;
    background: #f0f7ff !important;
    border-radius: 8px;
    font-weight: 600;
    color: #9c9d9f;
    font-size: 13px;
    color: #079e3e;
    border: 1px solid #079e3e;
  }

  .access-code-section {
    color: #000;

    .code-box {
      border: 2px dashed #cbcbcb;
      // width: 120px;
      padding: 7px 10px;
      border-radius: 5px;
      margin: 15px auto;
    }

    .head {
      font-size: 1.2rem;
      font-weight: 600;
    }
  }

  .status-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    height: 60px;
    padding: 20px 20px;
    position: fixed;
    width: 100%;
    z-index: 111;
    top: 0;
    box-sizing: border-box;

    .logo {
      width: 180px;
      height: 100%;
      cursor: pointer;
      margin-right: 66px;
    }
  }

  .payment-success-status {
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 10px;
    height: 100%;

    .modal-content {
      .background-img {
        background: url('../assets/images/dashboard/dialog-background.png');
        background-repeat: no-repeat;
        background-position: center center;
        height: 270px;
        padding: 20px;
        border-radius: 10px;

        h1 {
          margin: 0px 0 10px 0;
        }

        img {
          width: 150px;
        }
      }

      .new-model-inner {
        border-radius: 8px;
        padding: 20px 40px;
        background-color: #fff;
        max-width: 280px;

        h2 {
          color: #079e3e;
          font-size: 1.3rem;
          font-weight: 600;
        }

        p {
          font-size: 0.7rem;
          font-weight: 600;
          color: #000000;
        }

        .agreement-text {
          font-size: 0.7rem;
          font-weight: 500;
          color: #000000;
        }

        .proceed-btn {
          color: #fff;
          background-color: #079e3e;
          width: 100%;
          border-radius: 8px;
          font-size: 0.8rem;
          font-weight: 500;
        }
      }

      .model-outline {
        height: 20px;
        background: #079e3e;
        border-radius: 8px;
        position: relative;
        bottom: 15px;
        z-index: -1;
      }
    }
  }

  .payment-failure-status {
    display: flex;
    align-items: center;
    justify-content: center;

    .modal-content {
      background: #fff;
      padding: 40px 20px;
      border-radius: 10px;
    }

    .msg {
      h1 {
        margin-top: 10px;
      }

      img {
        width: 40px;
      }
    }
  }

  @media screen and (max-width: 650px) {
    .payment-success-status {
      .modal-content {
        .background-img {
          background: url('../assets/images/dashboard/dialog-background.png');
          background-repeat: no-repeat;
          background-position: center center;
          height: 290px;
        }

        .new-model-inner {
          width: auto;
        }
      }
    }
  }

  @media screen and (max-width: 440px) {
    .kyc_dialog .content-section .btn-secondary-theme-filled {
      margin-left: 0 !important;
    }
  }
}
</style>
<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.ProcessKycComponent {
  .agreement-checkbox {
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #2d2e8d;
      border-color: #2d2e8d;
    }

    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
      border-color: #ffffff;
    }

    .text {
      color: #000000;
      font-size: 9px;
      word-break: normal;
    }

    .el-checkbox__inner {
      width: 12px;
      height: 12px;
      bottom: 8px;
    }

    .el-checkbox__inner::after {
      height: 6px;
      left: 3px;
      top: 0px;
    }
  }

  .mobile-view {
    display: none;
  }

  .user-box-width {
    width: 165px;
  }

  .plan-subscription-notification-dialog {
    .chat-congratulation-text {
      font-size: 0.8rem;
      font-weight: 600;
      color: #000;
      width: 260px;
    }

    .el-dialog {
      background: transparent;
      box-shadow: none;
      width: 320px;
    }

    .el-dialog__body {
      word-break: break-word;
      padding: 0;
    }

    .el-dialog__header {
      padding: 0;
    }
  }

  .kyc-completed-popup {
    .el-dialog {
      width: 340px;
      border-radius: 8px;
    }

    h2 {
      color: #079e3e;
      font-size: 1.3rem;
      font-weight: 600;
    }

    p {
      font-size: 0.8rem;
      font-weight: 500;
      color: #000;
    }

    .el-button {
      background-color: #079e3e;
      border: 1px solid #079e3e;
    }

    .el-button:hover {
      color: #079e3e;
      border: 1px solid #079e3e;
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 20px;
      padding-bottom: 30px;
      word-break: normal;
    }
  }

  .el-button {
    padding: 7px;
  }

  .new-mobile-email-verification-dialog {
    h2 {
      font-weight: 600;
      color: #000;
    }

    .el-dialog__body {
      word-break: normal !important;
      text-align: left;
    }

    .email-mobile-block {
      margin-bottom: 2px;
    }

    .top-head {
      font-size: 12px;
      color: #000;
      font-weight: 500;
    }

    .norml-txt {
      font-size: 10px;
      color: #878787;
      font-weight: 500;
      margin-bottom: 5px;
    }

    .el-input-group__prepend {
      background-color: #ffffff;
      color: #000000;
      font-weight: 600;
      font-size: 14px;
      border: 1px solid #dcdfe6;
    }
  }

  .mobile-verification-dialog {
    .otp-input {
      width: 30px;
      height: 30px;
      padding: 5px;
      margin: 0 12px;
      font-size: 20px;
      border-radius: 4px;
      border: 1px solid #ebeaea;
      text-align: center;
      background-color: #f3f3f3;

      &.error {
        border: 1px solid red !important;
      }
    }

    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .mobile-verification-compo {
      display: flex;
      justify-content: center;
    }

    .el-dialog {
      border-radius: 10px;
      width: 350px;
    }

    .el-dialog__header {
      background-color: $secondary-theme-color;
      border-radius: 10px 10px 0 0;
      text-align: center;
      padding: 15px;
    }

    .el-dialog__title {
      line-height: 15px;
      font-size: 16px;
      color: #ffff;
      font-weight: 600;
    }

    .top-head {
      font-size: 12px;
      color: #000;
      font-weight: 500;
    }

    .norml-txt {
      font-size: 10px;
      color: #000;
      font-weight: 500;
    }

    .el-input__inner {
      border: none;
      border-bottom: 1px solid gray;
      border-radius: 0;
      text-align: center;
      color: #000;
      font-weight: 600;
    }

    .el-dialog__body {
      padding: 30px;
    }

    .otp-btn {
      border-radius: 4px;
      margin-top: 40px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #ffffff;
    }
  }

  .verify_otp_dialog {
    .verified-btn {
      width: 100%;
      padding: 7px;
      // border: 1px solid;
      font-size: 12px;
      border-radius: 8px;
      color: green;
      background: #e5ffe5;
    }

    .el-dialog {
      width: 400px;
      border-radius: 8px;
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding-top: 10px;
    }
  }

  .kyc_dialog {
    .el-collapse-item__header .el-collapse-item__arrow {
      display: block !important;
    }

    .el-dialog {
      width: 610px;
      border-radius: 8px;
      margin-top: 65px !important;
    }

    .el-dialog__body {
      border-radius: 8px;
      color: #000;
      background-color: #f0f7ff;
    }

    .el-dialog__body,
    .el-dialog__header {
      padding: 0;
    }

    .img-section {
      border-radius: 8px;
      padding: 0px 10px;
      border-radius: 8px 0 0 8px;
      // height: 400px;
    }

    .content-section {
      border-radius: 0 8px 8px 0;
      padding: 20px;
      background-color: #ffff;
      min-height: 270px;
      width: 100%;

      .email-box {
        width: 85%;
      }

      h3 {
        font-size: 1.1rem;
        font-weight: 600;
        margin-top: 0px;
      }
    }

    .el-collapse-item {
      background-color: #f0f7ff !important;
      border-bottom: none !important;
      margin: 20px 0;
      padding: 15px;
      border-radius: 8px;
    }

    .el-collapse-item__header.is-active {
      color: #2d2e8d;
    }

    .el-collapse-item__header {
      font-weight: 600;
      color: #9c9d9f;
    }

    .captcha-outer {
      color: #2d2e8d;
      font-weight: 500;
      font-size: 1.2rem;

      i {
        font-weight: 600;
        margin-left: 10px;
      }
    }

    .captcha {
      height: 50px;
      width: 200px;
      background-color: #ffff;
      margin: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .detail-box {
      border: 1px solid #d3d1d1;
      border-radius: 4px;
      padding: 5px 15px;
      font-size: 12px;
      color: #c0c4cc;
      background-color: #f5f7fa;
      margin-top: 3px;
    }

    .el-input--mini .el-input__inner {
      font-size: 16px !important;
    }
  }

  .risk-profile {
    .risk-profile-buttons {
      width: 200px;
    }

    .el-dialog {
      width: 650px;
      border-radius: 8px;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #2d2e8d;
    }

    .el-radio__input.is-checked .el-radio__inner {
      border-color: #2d2e8d;
      background: #2d2e8d;
    }

    .el-radio__label {
      font-size: 0.8rem;
    }

    h4 {
      font-weight: 500;
      margin-top: 0;
    }

    .progress-bar {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }

    .question {
      font-weight: 500;
      margin-top: 40px;
      height: 40px;
    }

    .img-section {
      height: 400px;
    }

    .content-section {
      min-height: 400px;
      width: 100%;
    }

    .step {
      flex: 1;
      text-align: center;
      position: relative;
      font-size: 14px;
      margin: 0 5px;
    }

    .step:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 100%;
      background-color: #ddd;
      /* Change this color as needed */
      height: 5px;
      border-radius: 10px;
      // background-color: #d75656;
    }

    .step.active {
      color: #4caf50;
      /* Change this color for active steps */
      margin: 0 5px;
    }

    .step.active:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 100%;
      height: 5px;
      border-radius: 10px;
      background-color: #d75656;
    }
  }

  .btn-gradient {
    background-image: linear-gradient(to left, #dc6250, #eb5151);
    outline: none;
    border-radius: 25px;
    height: 25px;
    line-height: 1.5px;
    color: #fff;
    font-size: 14px;
    border: none;
    cursor: pointer;
  }

  .el-step.is-vertical .el-step__title {
    color: #000000;
    font-size: 0.7rem;
  }

  .el-step__icon {
    width: 18px;
    height: 18px;
    font-size: 10px;
    color: #409eff;
  }

  .el-step__icon.is-text {
    border-radius: 50%;
    border: none;
    border-color: inherit;
    background: #c9e4ff;
    color: #409eff;
    position: relative;
    top: -2px;
  }

  .el-step.is-vertical .el-step__head {
    width: 22px;
  }

  .el-step__icon-inner {
    line-height: 1;
  }

  .el-step__icon-inner[class*='el-icon']:not(.is-status) {
    font-size: 13px;
    font-weight: 600;
    background: #c9e4ff;
    color: #409eff;
    height: 13px;
    width: 12px;
    border-radius: 50%;
    position: relative;
    top: 1px;
    padding: 5px 5px 3px 5px;
  }

  .horizontal-steps {
    margin-top: 40px;
    margin-bottom: 20px;

    .el-step__title.is-process {
      font-weight: 600;
      color: #2d2e8d;
    }

    .el-step__title {
      font-size: 10px;
      line-height: normal;
      position: relative;
      bottom: 50px;
    }

    .el-step__icon.is-text {
      top: 0;
    }

    .el-step__icon.is-text {
      background: #2d2e8d;
      color: #ffffff;
      top: 0;
    }

    .el-step__icon-inner[class*='el-icon']:not(.is-status) {
      font-size: 17px;
      background: transparent;
      color: #2d2e8d;
      height: auto;
      width: auto;
      border-radius: 50%;
      position: relative;
      top: 2px;
      padding: 0px;
    }
  }
}

@media screen and (max-width: 650px) {
  .kyc_dialog .el-dialog {
    width: 95% !important;
  }

  .kyc_dialog .content-section {
    width: 94% !important;
  }

  .verify_otp_dialog .el-dialog {
    width: 95% !important;
    border-radius: 8px;
  }

  .ProcessKycComponent {
    .mobile-view {
      display: block;
    }

    .desktop-view {
      display: none;
    }

    .user-box-width {
      width: 48%;
    }

    .kyc_dialog .content-section {
      border-radius: 8px;
      padding: 20px;

      .email-box {
        width: 85% !important;
      }

      .el-radio__label {
        white-space: normal;
        word-wrap: break-word;
        max-width: 320px;
      }
    }

    .risk-profile {
      .risk-profile-buttons {
        width: 50%;
      }

      .question {
        height: 60px;
      }
    }
  }
}

@media screen and (max-width: 430px) {
  .ProcessKycComponent {
    .user-box-width {
      width: 100%;
    }

    .verify_otp_dialog .verified-btn,
    .btn-secondary-theme-filled {
      margin-left: 5px !important;
    }

    .new-mobile-email-verification-dialog {
      .form-group .el-input {
        width: 180px !important;
      }

      h2 {
        font-size: 14px;
      }
    }

    .el-input-group__prepend {
      padding: 0 10px;
    }

    .verify_otp_dialog .el-dialog__body {
      padding: 20px 15px 30px;
    }
  }
}

@media screen and (max-width: 400px) {
  .ProcessKycComponent {
    .plan-subscription-notification-dialog {
      .chat-congratulation-text {
        width: auto;
      }

      .el-dialog {
        width: 310px;
      }
    }

    .user-box-width {
      width: 100%;
    }
  }

  .ProcessKycComponent .kyc-completed-popup .el-dialog {
    width: 95%;
    margin: 0 auto;
  }
}
</style>